import { Box, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";

// TabPanel component for tab content
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scheme-tabpanel-${index}`}
      aria-labelledby={`scheme-tab-${index}`}
      {...other}
      style={{ padding: "16px 0" }}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export const SpecialTeamsSchemes = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Box
    sx={{
      p: 1,
      maxWidth: 1600,
      width: "100%",
      bgcolor: "#121212",
      color: "white",
      height: "100vh",
      boxSizing: "border-box",
    }}
  >
    <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          "& .MuiTabs-indicator": {
            backgroundColor: "rgba(123, 45, 58, 0.9)",
          },
          "& .MuiTab-root": {
            color: "rgba(255, 255, 255, 0.7)",
            "&.Mui-selected": {
              color: "white",
            },
          },
        }}
      >
        <Tab label="Kickoff" id="scheme-tab-0" />
        <Tab label="Kickoff Return" id="scheme-tab-1" />
        <Tab label="Punt" id="scheme-tab-2" />
        <Tab label="Punt Return" id="scheme-tab-3" />
        <Tab label="Field Goal" id="scheme-tab-4" />
        <Tab label="Field Goal Block" id="scheme-tab-5" />
      </Tabs>
    </Box>
    </Box>
  );
};
